module.exports = __webpack_public_path__ + "static/media/web-pop-up.d31f035b.jpg";